import React, { useEffect, useState } from 'react';
import { Zap, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { apiClient } from '../api';

const BoostButton = () => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const r = await apiClient.get('/boost/status');
      setStatus(r.data);
    } catch (err) {
      console.warn('Boost status load failed:', err?.message);
    }
  };

  useEffect(() => { load(); }, []);

  const activate = async () => {
    setBusy(true);
    try {
      const r = await apiClient.post('/boost/activate');
      setStatus({ ...status, active: true, boost_until: r.data.boost_until });
      toast.success('You\'re boosted!', {
        description: 'You\'re at the top of the browse page for the next 30 minutes.',
      });
    } catch (err) {
      const detail = err.response?.data?.detail || '';
      if (err.response?.status === 429) {
        toast('Boost on cooldown', { description: 'You can boost again in a bit.' });
      } else {
        toast.error('Could not boost', { description: detail });
      }
    } finally {
      setBusy(false);
    }
  };

  const active = status?.active;
  const credits = status?.credits || 0;
  const buttonClass = active
    ? 'bg-gradient-to-r from-yellow-400 to-fnl-pink text-white font-bold'
    : 'bg-fnl-pink hover:bg-fnl-pink text-white font-bold';

  let label;
  if (active) {
    label = <><Sparkles className="w-4 h-4 mr-2" />Boost active</>;
  } else if (credits > 0) {
    label = <><Zap className="w-4 h-4 mr-2" />Boost me ({credits} free)</>;
  } else {
    label = <><Zap className="w-4 h-4 mr-2" />Boost me</>;
  }

  return (
    <Button
      onClick={activate}
      disabled={busy || active}
      className={`${buttonClass} btn-shadow-pink h-11 px-5`}
      data-testid="boost-btn"
    >
      {label}
    </Button>
  );
};

export default BoostButton;
